import { render } from "./CandidatesView.vue?vue&type=template&id=ba22df32"
import script from "./CandidatesView.vue?vue&type=script&lang=js"
export * from "./CandidatesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__